// @ts-nocheck
import { ReactNode } from 'react'
import {
  ButtonsContainer,
  CancelButton,
  CloseButtonIcon,
  DataContainer,
  DataTitleText,
  DataValueText,
  SaveButton,
  StyledModal,
  SubTitleText,
  TitleAndIconContainer,
  TitleAndSubtitleContainer,
  TitleAndValueDataContainer,
  TitleText,
} from './styles'
import closeButtonIcon from '../../assets/close-button.svg'

interface CustomModalProps {
  isOpen: boolean
  onRequestClose?: () => void
  children?: ReactNode
  nationalRegistration?: string
  accountOwner?: string
  bank?: string
  agency?: string
  accountType?: string
  accountNumber?: string
  accountDigit?: string
  accountIdentifier?: string
  pixKey?: string
  pixTypeKey?: string
  transactionType?: string
  saveButton?: VoidFunction
  isPix?: boolean
  disabledButtons?: boolean
}

export const CustomResumeModal = ({
  isOpen,
  children,
  onRequestClose,
  isPix,
  nationalRegistration,
  accountOwner,
  bank,
  agency,
  accountType,
  accountNumber,
  accountDigit,
  accountIdentifier,
  transactionType,
  pixKey,
  pixtypeKey,
  saveButton,
  disabledButtons,
}: CustomModalProps) => {
  return (
    <StyledModal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      isPix={isPix}
      style={{
        overlay: {
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
        },
      }}
    >
      {isPix ? (
        <>
          <TitleAndIconContainer>
            <TitleAndSubtitleContainer>
              <TitleText>Confirmação de Conta</TitleText>
              <SubTitleText>
                Confira abaixo os dados da conta cadastrada
              </SubTitleText>
            </TitleAndSubtitleContainer>
            <CloseButtonIcon onClick={onRequestClose} src={closeButtonIcon} />
          </TitleAndIconContainer>

          <DataContainer>
            <TitleAndValueDataContainer>
              <DataTitleText>CPF/CNPJ</DataTitleText>
              <DataValueText>{nationalRegistration}</DataValueText>
            </TitleAndValueDataContainer>
            <TitleAndValueDataContainer>
              <DataTitleText>Titular</DataTitleText>
              <DataValueText>{accountOwner}</DataValueText>
            </TitleAndValueDataContainer>
            <TitleAndValueDataContainer>
              <DataTitleText>Tipo de transação</DataTitleText>
              <DataValueText>{transactionType}</DataValueText>
            </TitleAndValueDataContainer>
            <TitleAndValueDataContainer>
              <DataTitleText>Chave PIX</DataTitleText>
              <DataValueText>{pixKey}</DataValueText>
            </TitleAndValueDataContainer>
          </DataContainer>

          <ButtonsContainer>
            <CancelButton onClick={onRequestClose} disabled={disabledButtons}>
              Cancelar
            </CancelButton>
            <SaveButton onClick={() => saveButton()} disabled={disabledButtons}>
              Confirmar Conta
            </SaveButton>
          </ButtonsContainer>
        </>
      ) : (
        <>
          <TitleAndIconContainer>
            <TitleAndSubtitleContainer>
              <TitleText>Confirmação de Conta</TitleText>
              <SubTitleText>
                Confira abaixo os dados da conta cadastrada
              </SubTitleText>
            </TitleAndSubtitleContainer>
            <CloseButtonIcon onClick={onRequestClose} src={closeButtonIcon} />
          </TitleAndIconContainer>

          <DataContainer>
            <TitleAndValueDataContainer>
              <DataTitleText>CPF/CNPJ</DataTitleText>
              <DataValueText>{nationalRegistration}</DataValueText>
            </TitleAndValueDataContainer>
            <TitleAndValueDataContainer>
              <DataTitleText>Titular</DataTitleText>
              <DataValueText>{accountOwner}</DataValueText>
            </TitleAndValueDataContainer>
            <TitleAndValueDataContainer>
              <DataTitleText>Tipo de transação</DataTitleText>
              <DataValueText>{transactionType}</DataValueText>
            </TitleAndValueDataContainer>
            <TitleAndValueDataContainer>
              <DataTitleText>Banco</DataTitleText>
              <DataValueText>{bank}</DataValueText>
            </TitleAndValueDataContainer>
            <TitleAndValueDataContainer>
              <DataTitleText>Agência</DataTitleText>
              <DataValueText>{agency}</DataValueText>
            </TitleAndValueDataContainer>
            <TitleAndValueDataContainer>
              <DataTitleText>Tipo de conta</DataTitleText>
              <DataValueText>{accountType}</DataValueText>
            </TitleAndValueDataContainer>
            <TitleAndValueDataContainer>
              <DataTitleText>N° da Conta</DataTitleText>
              <DataValueText>{accountNumber}</DataValueText>
            </TitleAndValueDataContainer>
          </DataContainer>

          <ButtonsContainer>
            <CancelButton onClick={onRequestClose} disabled={disabledButtons}>
              Cancelar
            </CancelButton>
            <SaveButton onClick={() => saveButton()} disabled={disabledButtons}>
              Confirmar Conta
            </SaveButton>
          </ButtonsContainer>
        </>
      )}

      {children}
    </StyledModal>
  )
}
